export default [
  {
    path: '/synchronization',
    name: 'synchronization-list',
    props: true,
    component: () => import('@/views/synchronization/Index.vue'),
    meta: {
      requireLogin: true,
      pageDesc: 'Consultez et gérez les synchronisations de données logistiques entre la plateforme et les fournisseurs.',
      accessibility: {
        ariaLabel: 'Liste des synchronisations logistiques',
        breadcrumbLabel: 'Fil d’Ariane des synchronisations',
      },
      breadcrumb: [
        {
          text: 'Synchronisation',
          to: { name: 'synchronization-list' },
          ariaLabel: 'Accueil synchronisation',
        },
        {
          text: 'Liste des synchronisations',
          active: true,
          ariaLabel: 'Liste des synchronisations',
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/synchronization/state',
    name: 'sync-state-orders',
    props: true,
    component: () => import('@/views/synchronization/SyncStateOrders.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'État de synchronisation',
      pageDesc: 'Consultez les colis assignés à une société externe mais sans code externe.',
      accessibility: {
        ariaLabel: 'Liste des échecs de synchronisation',
        breadcrumbLabel: 'Fil d’Ariane des échecs de synchronisation',
      },
      breadcrumb: [
        {
          text: 'État de synchronisation',
          to: { name: 'sync-state-orders' },
          ariaLabel: 'Accueil état de synchronisation',
        },
        {
          text: 'Liste',
          active: true,
          ariaLabel: 'Liste des échecs de synchronisation',
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
]
